import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import cx from "classnames";

import t, { AsHtml } from "../../utils/translate";
import NextButton from "../NextButton";
import useAppContext from "components/AppContext";
import {
  initialPathClinical2,
  initialPathFoodNoise,
  loginUrl,
  logout
} from "utils/profile";
import clearStorageAndCookies from "utils/clearStorageAndCookies";
import { getClinicTabData } from "utils/getClinicTabData";

import styles from "./styles.module.scss";

export default function StickyFooter({
  nextButtonProps,
  message = { label: "", className: "" },
  className = "",
  isIntro = false
}) {
  const { authData, setAuthData, newQuiz } = useAppContext();
  const { loggedInAs } = authData || {};
  const { isDisabled } = nextButtonProps;
  const { isFromClinicTab } = getClinicTabData();

  useEffect(() => {
    const rootElement = document.getElementById("root");
    rootElement.appendChild(containerRef.current);
    return () => {
      rootElement.removeChild(containerRef.current);
    };
  }, []);

  const handleLogout = e => {
    e.preventDefault();

    if (loggedInAs && setAuthData) {
      clearStorageAndCookies();
      setAuthData({
        ...authData,
        loggedInAs: ""
      });
      const logoutPathClincal = `${window.location.origin}${initialPathClinical2}`;
      const logoutPathFoodNoise = `${window.location.origin}${initialPathFoodNoise}`;
      logout(newQuiz.isClinical ? logoutPathClincal : logoutPathFoodNoise);
    }
  };

  const handleLogin = e => {
    if (loggedInAs) {
      handleLogout(e);
    } else {
      e.preventDefault();
      window.sessionStorage.setItem("attemptedLogin", true);
      window.location.href = loginUrl(window.location.href);
    }
  };

  const containerRef = useRef(document.createElement("div"));

  return ReactDOM.createPortal(
    <div
      className={cx(styles.stickyWrapper, className, {
        [styles.wrapperWithMessage]: message?.label,
        [styles.reverse]: newQuiz.isFoodNoise || newQuiz.isClinical,
        [styles.hasLogout]: newQuiz.isClinical
      })}
    >
      {newQuiz.isClinical &&
        loggedInAs &&
        !window.ww.isTest &&
        !isFromClinicTab && (
          <div
            className={cx(styles.authSection, {
              [styles.authSectionBorder]: !isIntro
            })}
          >
            <AsHtml
              tagType="span"
              value={t("LOGOUT_TEXT")}
              interpolations={{ loggedInAs }}
            />
            <a className={styles.authLink} href="#" onClick={handleLogout}>
              {t("LOGOUT_LINK")}
            </a>
          </div>
        )}
      {newQuiz.isFoodNoise &&
        !window.ww.isTest &&
        ((isIntro && loggedInAs) || !isIntro) && (
          <div
            className={cx(
              styles.authSection,
              styles.authSectionBorder,
              styles.authSectionFoodNoise
            )}
          >
            {loggedInAs ? (
              <AsHtml
                tagType="span"
                value={t("LOGOUT_TEXT")}
                interpolations={{ loggedInAs }}
              />
            ) : (
              t("LOGIN_TEXT")
            )}
            <a className={styles.authLink} href="#" onClick={handleLogin}>
              {loggedInAs ? t("LOGOUT_LINK") : t("LOGIN_LINK")}
            </a>
          </div>
        )}
      <div className={styles.stickyContainer}>
        {nextButtonProps && (
          <NextButton
            tabIndex={0}
            {...nextButtonProps}
            overrideClassName={cx(styles.stickyNext, {
              [styles.disabled]: isDisabled
            })}
          />
        )}
      </div>
      {message?.label && (
        <AsHtml
          value={message?.label}
          className={cx(message?.className, styles.message)}
        />
      )}
      <label className={styles.hidden} htmlFor="g-recaptcha-response-100000">
        Recaptcha
      </label>
    </div>,
    containerRef.current
  );
}
